const items = [
  "COMPASSION",
  "OPPORTUNITY",
  "MOTIVATION",
  "SAFE SPACES",
  "STRONGER TOMORROWS",
  "ASAM 3.3 RESIDENTIAL CARE",
  "PETERSBURG MALE MANOR",
  "HONORING JALIYAH",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="bg-[#5B21B6] text-[#FAF8F5] py-4 overflow-hidden border-y-4 border-amber-400">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((t, i) => (
              <span key={`${half}-${i}`} className="flex items-center whitespace-nowrap">
                <span className="font-display italic font-semibold text-lg sm:text-xl tracking-wide px-6">{t}</span>
                <span className="text-amber-400 text-xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
